module.exports = __webpack_public_path__ + "img/ba2.85977503.jpg";